module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "share"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [
    [_c('img', {
      key: 'dom1',
      staticClass: "cup",
      attrs: {
        "src": require("../assets/answer-share/cup.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      key: 'dom11',
      staticClass: "cup-child",
      attrs: {
        "src": require("../assets/answer-share/cup-child.png"),
        "alt": ""
      }
    }), _vm._v(" "), (!_vm.tmp_data.prize) ? _c('p', {
      key: 'dom2',
      staticClass: "part2"
    }, [_vm._v(_vm._s(_vm.$t('shareComm')))]) : _c('div', {
      key: 'dom41',
      staticClass: "show_prize"
    }, [_c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.$t('shareBouns')))]), _vm._v(" "), _c('p', {
      staticClass: "number"
    }, [_vm._v("$"), _c('span', [_vm._v(_vm._s(_vm.tmp_data.prize))])])]), _vm._v(" "), _c('div', {
      key: 'dom3',
      staticClass: "part3"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('download')))]), _c('img', {
      attrs: {
        "src": require("../assets/answer-share/AFlogo.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      key: 'dom4',
      staticClass: "part4"
    }, [_vm._v(_vm._s(_vm.$t('share')))]), _vm._v(" "), _c('div', {
      key: 'dom5',
      staticClass: "code-box"
    }, [_c('p', [_vm._v(_vm._s(_vm.tmp_data.code))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.tmp_data.code),
        expression: "tmp_data.code",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.copySuccess),
        expression: "copySuccess",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.copyError),
        expression: "copyError",
        arg: "error"
      }],
      staticClass: "ok_btn"
    }, [_c('img', {
      staticClass: "code-sure",
      attrs: {
        "src": require("../assets/answer-share/copy.png"),
        "alt": ""
      }
    }), _vm._v(_vm._s(_vm.$t('copy')) + "\n                ")])]), _vm._v(" "), _c('div', {
      key: 'dom6',
      staticClass: "download",
      on: {
        "click": _vm.download
      }
    }, [_vm._v(_vm._s(_vm.$t('download'))), _c('img', {
      attrs: {
        "src": require("../assets/answer-share/download.png"),
        "alt": ""
      }
    })])]
  ], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ffbe128","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppAnswerShare.vue
// module id = 828
// module chunks = 9